import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const BookingForm = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [state, setState] = useState("idle"); // idle | sending | sent | error
  const [err, setErr] = useState("");

  const change = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (state === "sending") return;

    const name = form.name.trim();
    const email = form.email.trim();
    const message = form.message.trim();
    if (!name || !EMAIL_RE.test(email) || message.length < 5) {
      setErr("Please add your name, a valid email and a quick note.");
      return;
    }
    setErr("");
    setState("sending");
    try {
      const res = await fetch(`${API}/booking`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, message }),
      });
      if (!res.ok) throw new Error("network");
      setState("sent");
    } catch (_) {
      setState("error");
      setErr("Couldn't send — try again, or email info@mystmusic.io directly.");
    }
  };

  return (
    <div className="booking-wrap reveal" style={{ "--d": ".34s" }}>
      <AnimatePresence mode="wait">
        {state === "sent" ? (
          <motion.div
            key="ok"
            className="booking-ok"
            data-testid="booking-success"
            initial={{ opacity: 0, y: 24, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          >
            <span className="booking-ok-eyebrow">Got it</span>
            <h3>We got it.</h3>
            <p>Our booking agent will reply within 24 hours.</p>
          </motion.div>
        ) : (
          <motion.form
            key="form"
            className="booking-form"
            data-testid="booking-form"
            onSubmit={submit}
            noValidate
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <label className="booking-field">
              <span>Name</span>
              <input
                type="text"
                value={form.name}
                onChange={change("name")}
                placeholder="Your name"
                autoComplete="name"
                required
                data-testid="booking-name"
              />
            </label>
            <label className="booking-field">
              <span>Email</span>
              <input
                type="email"
                value={form.email}
                onChange={change("email")}
                placeholder="you@studio.com"
                autoComplete="email"
                required
                data-testid="booking-email"
              />
            </label>
            <label className="booking-field booking-field-wide">
              <span>Message</span>
              <textarea
                rows={4}
                value={form.message}
                onChange={change("message")}
                placeholder="Tell us what you're planning — session, listening party, wedding, shoot…"
                required
                data-testid="booking-message"
              />
            </label>
            {err && <p className="booking-err" data-testid="booking-error">{err}</p>}
            <button
              type="submit"
              className="booking-submit"
              disabled={state === "sending"}
              data-testid="booking-submit"
            >
              {state === "sending" ? "Sending…" : "Send booking enquiry"}
            </button>
          </motion.form>
        )}
      </AnimatePresence>
    </div>
  );
};
